<div class="container">
  <br>
  <form class="search-form" [formGroup]="filterForm">
    <div class="row">
      <div class="col-sm-12">
    <fieldset class="mat-mdc-card sgd-card" style="padding-top: 0;">
      <legend>&nbsp;Buscar por n&uacute;mero de flow&nbsp;</legend>
      <br>
      <div class="col-lg-12 col-md-12">
        <div style="display: flex;">
          <mat-form-field style="width: 100%;">
            <mat-label>N&uacute;mero Flow</mat-label>
            <input type="text" matInput placeholder="2025-67673 o 67673" value="" formControlName="numero"
              (keypress.enter)="fectchAndInitializeDataSource()" />
            <mat-hint>Ingresar a&ntilde;o-n&uacute;mero o n&uacute;mero, ejemplo: 2025-1523 / 75896</mat-hint>
            @if((filterForm.controls.numero.value)){
            <button type="button" matSuffix mat-icon-button aria-label="Limpiar"
              (click)="filterForm.controls.numero.setValue(''); buscarFlow();">
              <mat-icon>close_small</mat-icon>
            </button>
            }
            <button type="button" matSuffix mat-icon-button aria-label="Buscar" (click)="buscarFlow()">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      </fieldset>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <mat-card class="sgd-card col-sm-12">
          <div class="participantes-container">
            <div style="position: absolute; right: 10px; top: 10px;">
              <button type="button" mat-flat-button color="primary" (click)="openDlgDestino()"
                matTooltip="Seleccionar participantes">
                <mat-icon>person_search</mat-icon>Seleccionar Participantes
              </button>
            </div>
            <mat-card-subtitle>
              De: &nbsp;
              @for (participante of participantes.origen; track $index) {
              <div class="participante-label">
                <!--<img src="assets/vacio.png" class="foto-para">-->
                <mat-icon>account_circle</mat-icon>
                <span>
                  {{participante.nombres | capitalize}}
                </span>
              </div>
              }
            </mat-card-subtitle>
            <mat-card-subtitle>
              Para:
              @for (participante of participantes.destino; track $index) {
              <div class="participante-label">
                <!--<img src="assets/vacio.png" class="foto-para">-->
                <mat-icon>person</mat-icon>
                <span>
                  {{participante.nombres | capitalize}}
                </span>
              </div>
              }
            </mat-card-subtitle>
            <mat-card-subtitle>
              @if (participantes.copia.length){
              Copia:
              @for (participante of participantes.copia; track $index) {
              <!--<img src="assets/vacio.png" class="foto-para">-->
              <div class="participante-label">
                <mat-icon>contact_page</mat-icon>
                <span>
                  {{participante.nombres | capitalize}}
                </span>
              </div>
              }
              }
            </mat-card-subtitle>
          </div>
        </mat-card>
      </div>
    </div>
    
    <div class="row">      
      <div class="col-lg-6 col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Tipo documento</mat-label>
          <mat-select formControlName="documentType">
            <mat-option value="-1" selected>Todos</mat-option>
            @for (documentType of documentTypes; track $index) {
            <mat-option value={{documentType.id}}>{{documentType.descripcion}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-6">
        <mat-form-field class="full-width">
          <mat-label>No. documento</mat-label>
          <input type="text" matInput placeholder="" value="" formControlName="numeroDocumento"
            (keypress.enter)="fectchAndInitializeDataSource()" />
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="fechaInicio" [max]="maxDate" formControlName="fechaInicio"
            (keypress.enter)="fectchAndInitializeDataSource()">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaInicio"></mat-datepicker-toggle>
          <mat-datepicker #fechaInicio></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6">
        <mat-form-field class="full-width">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="fechaFin" [max]="maxDate" formControlName="fechaFin"
            (keypress.enter)="fectchAndInitializeDataSource()">
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="fechaFin"></mat-datepicker-toggle>
          <mat-datepicker #fechaFin></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12">                
        <mat-form-field class="full-width">          
          <mat-label>Asunto</mat-label>
          <input matInput placeholder="Asunto" formControlName="searchText" minlength="4"
            (keypress.enter)="fectchAndInitializeDataSource()" />          
          <button type="button" mat-icon-button color="accent" matPrefix matTooltip="Consejos para b&uacute;squeda" (click)="onAyuda()">
                <mat-icon>help</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div class="search-div">
      <button mat-button style="background-color: var(--mat-button-toggle-selected-state-background-color);"
        [disabled]="filterForm.invalid || isLoadingResults" (click)="fectchAndInitializeDataSource()">
        <mat-icon>search</mat-icon> Buscar</button>
      <button matButton="outlined" (click)="limpiarFiltros()">
        <mat-icon>clear</mat-icon> Limpiar</button>
    </div>
  </form>

  <mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear matSortDirection="desc">
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="movimiento">
      <mat-header-cell *matHeaderCellDef>Mov.</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.idTarea }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="estados">
      <mat-header-cell *matHeaderCellDef>N&uacute;mero</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        <div>{{ element.anio + "-" + element.numero }}</div>
        <app-estados-documento [documento]="element"></app-estados-documento>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="de">
      <mat-header-cell *matHeaderCellDef>De</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @for (item of element.de; track $index) {
        <p>{{item.nombres}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="para">
      <mat-header-cell *matHeaderCellDef>Para</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        @for (item of element.para; track $index) {
        <p>{{item.nombres}}</p>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="asunto">
      <mat-header-cell *matHeaderCellDef>Asunto</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.asunto }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">
        {{ formatDate(element.fecha) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroReferencia">
      <mat-header-cell *matHeaderCellDef>No. Referencia</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.numeroReferencia }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="numeroDocumento">
      <mat-header-cell *matHeaderCellDef>No. Documento</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.numeroDocumento }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="usuarioAnterior">
      <mat-header-cell *matHeaderCellDef>Usuario anterior</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.usuarioAnterior }}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:false"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="mostrarResumen(row)"></mat-row>
    @if(!isLoadingResults){
    <div class="mat-row no-data-found" *matNoDataRow><app-no-data-found /></div>
    }
  </mat-table>
  @if(isLoadingResults){
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-paginator #paginator [length]="resultsLength" pageSize="25" hidePageSize aria-label="Paginador">
  </mat-paginator>
</div>